import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Modal,
  IconButton,
} from "@mui/material";
import React from "react";
import CustomText from "../../customComponents/customText";
import { Colors } from "../../assets/colors";
import PropTypes from "prop-types";
import ZarImg from "../../assets/images/zar.png";
import AnuragImg from "../../assets/images/anurag.png";
import UdayaImg from "../../assets/images/udaya.png";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { youTubeUrl } from "../../assets/function";
import CloseIcon from '@mui/icons-material/Close';

const FounderInfo = () => {
  const [open, setOpen] = React.useState(false);
  const [selectedVideo, setSelectedVideo] = React.useState('');
  const [hoverTimer, setHoverTimer] = React.useState(null);

  const handleOpen = (videoUrl) => {
    setSelectedVideo(videoUrl);
    setOpen(true);
  };

  const handleClose = () => {
    if (hoverTimer) clearTimeout(hoverTimer);
    setOpen(false);
  };

  // const copyToClipboard = (text) => {
  //   navigator.clipboard.writeText(text);
  //   // Optional: Add a toast notification here
  // };

  const PersonCard = ({
    imageValue,
    textValue,
    name,
    companyName,
    occupation,
    videoUrl,
  }) => (
    <Box
      onMouseEnter={() => {
        const timer = setTimeout(() => handleOpen(videoUrl), 1000);
        setHoverTimer(timer);
      }}      
      onMouseLeave={() => {
        if (hoverTimer) clearTimeout(hoverTimer);
        handleClose();
      }}
    >
    <Card 
      sx={styles.cardStyle} 

      elevation={0}
     
    >
      <CardActionArea sx={styles.cardActionBox}>
        <CardContent sx={styles.cardContentBox}>
          <CustomText
            desc={textValue}
            fontFamily="Inter"
            colorvalue={Colors.getAiReadyTxt}
            style={{
              ...styles.testimonialText,
              ...styles.getAiReadyTxt,
            }}
            h3
            fontWeight={400}
          />
          <Box sx={styles.bottomBox}>
            <CardMedia
              component="img"
              image={imageValue}
              alt="person"
              sx={{
                width: 80,
                height: 80,
                borderRadius: 3,
                objectFit: "cover",
              }}
            />
            <Box sx={styles.rightBox}>
              <CustomText
                desc={name}
                fontFamily="Inter"
                colorvalue={Colors.menuListBgColor}
                style={styles.getAiReadyTxt}
                h4
                fontWeight={400}
              />
              <CustomText
                desc={companyName}
                fontFamily="Inter"
                colorvalue={Colors.getAiReadyTxt}
                style={styles.getAiReadyTxt}
                h5
                fontWeight={400}
              />
              <CustomText
                desc={occupation}
                fontFamily="Inter"
                colorvalue={Colors.getAiReadyTxt}
                style={styles.getAiReadyTxt}
                p1
                fontWeight={400}
              />
            </Box>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
    </Box>
  );

  PersonCard.propTypes = {
    imageValue: PropTypes.string.isRequired,
    textValue: PropTypes.string,
    name: PropTypes.string.isRequired,
    companyName: PropTypes.string,
    occupation: PropTypes.string,
    videoUrl: PropTypes.string,
  };

  let settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Box sx={styles.appBarStyle}>
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        sx={styles.appBarStyle}
      >
        <Container maxWidth="xl" sx={styles.containerStyle}>
          <Slider {...settings} style={styles.container}>
            <PersonCard
              imageValue={ZarImg}
              textValue={
                '"The chatbot plugin designed and integrated by &aihub in our app is the best thing happened to us"'
              }
              name={"Zar"}
              companyName={"CocaCola"}
              occupation={"(vendor)"}
              videoUrl={youTubeUrl}
            />
            <PersonCard
              imageValue={AnuragImg}
              textValue={
                '"Yash info always needed a DocuAi to query all our documents and we are grateful for &adihub for that."'
              }
              name={"Anurag"}
              companyName={"Yash Info"}
              occupation={""}
              videoUrl={youTubeUrl}
            />
            <PersonCard
              imageValue={UdayaImg}
              textValue={
                '"andaihub is our one stop solution for all AI plugins, we have made a succesive progress in our ai system using their AI plugins"'
              }
              name={"Udaya"}
              companyName={"Nikshala"}
              occupation={""}
              videoUrl={youTubeUrl}
            />
            <PersonCard
              imageValue={ZarImg}
              textValue={
                '"The chatbot plugin designed and integrated by &aihub in our app is the best thing happened to us"'
              }
              name={"Zar"}
              companyName={"CocaCola"}
              occupation={"(vendor)"}
              videoUrl={youTubeUrl}
            />
            <PersonCard
              imageValue={AnuragImg}
              textValue={
                '"Yash info always needed a DocuAi to query all our documents and we are grateful for &adihub for that."'
              }
              name={"Anurag"}
              companyName={"Yash Info"}
              occupation={""}
              videoUrl={youTubeUrl}
            />
            <PersonCard
              imageValue={UdayaImg}
              textValue={
                '"andaihub is our one stop solution for all AI plugins, we have made a succesive progress in our ai system using their AI plugins"'
              }
              name={"Udaya"}
              companyName={"Nikshala"}
              occupation={""}
              videoUrl={youTubeUrl}
            />
          </Slider>
        </Container>
      </motion.div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="video-preview-modal"
      >
        <Box sx={styles.modalStyle}>
          <IconButton
            onClick={handleClose}
            sx={styles.closeButton}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Box sx={styles.iframeContainer}>
            <iframe
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
              src={`${selectedVideo.replace('watch?v=', 'embed/')}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
          
          
          {/* <Box sx={styles.videoLinkBox}>
            <Typography variant="body1" sx={{ flexGrow: 1 }}>
              Video Link: {selectedVideo}
            </Typography>
            <IconButton 
              onClick={() => copyToClipboard(selectedVideo)}
              color="primary"
            >
              <ContentCopyIcon />
            </IconButton>
          </Box> */}
        </Box>
      </Modal>
    </Box>
  );
};

const styles = {
  bottomBox: {
    flexDirection: "row",
    alignItems: "center",
    display: "flex",
    marginTop: { xs: 1.5, sm: 3 },
  },
  rightBox: {
    marginLeft: 2,
  },
  cardContentBox: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  cardActionBox: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  container: {
    width: "80%",
    margin: "0 auto", // Center the container
    
  },
  appBarStyle: {
    overflowX: "hidden", // Prevent horizontal scrolling
    boxSizing: "border-box",
    backgroundColor: Colors.themeColor,
    "& .slick-slide": {
      padding: "0 10px",
    },
    "& .slick-dots": {
      bottom:{xs:-26,md:-40},
    },
    "& .slick-prev, & .slick-next": {
      zIndex: 1,
      "&:before": {
        color: Colors.andaihubTxt,
      },
    },
    "& .slick-prev": {
      left: -25,
    },
    "& .slick-next": {
      right: -25,
    },
  },
  containerStyle: {
    display: "flex",
    marginTop: {xs:4,md:13},
    marginBottom: {xs:4,md:13},
    alignItems: "center",
    justifyContent: "center ",
  },
  cardStyle: {
    maxWidth: 400,
    marginRight: { xs: 0.5, sm: 1 },
    marginLeft: { xs: 0.5, sm: 1 },
    borderRadius: 4,
    padding: { xs: 1, sm: 2 },
    minHeight: { xs: 200, sm: 290 },
    height: "auto",
    display: "flex",
    flexDirection: "column",
    cursor: 'pointer',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  testimonialText: {
    minHeight: { xs: 80, sm: 120 },
    marginBottom: { xs: 1, sm: 2 },
    fontSize: {
      xs: "0.8rem",
      sm: "1rem",
      md: "1.1rem",
    },
    lineHeight: 1.5,
  },
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
      xs: '90%',    // Mobile
      sm: '80%',    // Tablet
      md: '70%',    // Desktop
    },
    minWidth: '300px', // Add minimum width
    minHeight: '200px', // Add minimum height
    maxHeight: '90vh', // Prevent modal from being taller than viewport
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    backgroundColor: Colors.themeColor,
    overflow: 'hidden', // Prevent content overflow
  },
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: 'grey.500',
  },
  videoLinkBox: {
    display: 'flex',
    alignItems: 'center',
    bgcolor: '#f5f5f5',
    p: 2,
    borderRadius: 1,
  },
  iframeContainer: {
    mt: { xs: 2, sm: 3, md: 4 },
    width: "100%",
    height: { 
      xs: "40vh", // Smaller height for mobile
      sm: "50vh", // Medium height for tablets
      md: "60vh",
      lg: "50vh",
      xl: "60vh"
    },
    minHeight: "200px",
    position: "relative",
    overflow: "hidden",
    aspectRatio: "16/9",

  },
};

export default FounderInfo;
